module.exports = __webpack_public_path__ + "static/media/emailChange.99049df2.svg";